module.exports = __webpack_public_path__ + "static/img/Easton_Wood_desktop.80101fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Easton_Wood_desktop.jpg
// module id = E3Nn
// module chunks = 0